/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import useApiRequest from "utils/Apirequest";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { isValidPassword } from "utils/Constant";

import { useMaterialUIController } from "context";


function ResetSupervisorPassword() {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();

  const apiRequest = useApiRequest();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const row_data = location.state || {};

  const getInitialValues = () => ({
    new_password: "",
    confirm_password: "",
    phoneNumber: row_data?.phoneNumber || "",
  });

  const [values, setValues] = useState(getInitialValues);

  useEffect(() => {
    setValues(getInitialValues);
  }, [row_data]);

  const createUser = async (new_password) => {
    const payload = {
      phoneNumber: values.phoneNumber,
      newPassword: new_password,
    };
    const { data } =
      (await apiRequest(
        "post",
        "supervisor/resetpassword",
        payload,
        {},
        { "Content-Type": "application/json" }
      )) || {};
    if (data?.success === true) {
      navigate("/supervisor");
    }
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!values.new_password || !values.confirm_password) {
      return enqueueSnackbar("All fields are necessary", {
        variant: "error",
      });
    }

    if (!isValidPassword(values.new_password)) {
      return enqueueSnackbar(
        "Password must be at least 8 characters and include 1 number and 1 special character",
        { variant: "error" }
      );
    }

    if (values.new_password !== values.confirm_password) {
      return enqueueSnackbar(
        "Passwords do not match. Please try again.",
        { variant: "error" }
      );
    }

    createUser(values.new_password);
  };

  const reset = (event) => {
    event.preventDefault();
    setValues(getInitialValues());
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Reset Password
                </MDTypography>
              </MDBox>

              <MDBox p={4} component="form" role="form">
                <MDBox p={1}>
                  <div className="disabled-input-wrapper">
                    <MDInput
                      disabled
                      type="text"
                      label="Phone Number"
                      value={values.phoneNumber}
                      name="phoneNumber"
                      margin="dense"
                      fullWidth
                      onChange={handleChange}

                    />
                  </div>
                </MDBox>
                <MDBox p={1}>
             
                  <MDInput
                    type={showNewPassword ? "text" : "password"}
                    label="New Password"
                    value={values.new_password}
                    name="new_password"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: values.new_password && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    onBlur={() => {
                      if (values.new_password && !isValidPassword(values.new_password)) {
                        enqueueSnackbar(
                          "Password must contain 1 number and 1 special character",
                          { variant: "warning" }
                        );
                      }
                    }}
                  />
                </MDBox>

                <MDBox p={1}>
                  {/* <MDInput
                    type="password"
                    label="Confirm Password"
                    value={values.confirm_password}
                    name="confirm_password"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  /> */}
                  <MDInput
                    type={showConfirmPassword ? "text" : "password"}
                    label="Confirm Password"
                    value={values.confirm_password}
                    name="confirm_password"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: values.confirm_password && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
       
                <style>
                  {`

                  .disabled-input-wrapper div{
                    background-color: ${controller.darkMode ? "#1a2035" : "#f0f2f5"} !important;
                          }
                  `}
                </style>
             
                <Grid
                  container
                  direction="row"
                  justifyContent="space-around"
                  p={2}
                >
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={reset}
                  >
                    Reset
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={handleSubmit}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ResetSupervisorPassword;
